import styled from "styled-components";

export const AwaitingDriverContainer = styled.div`
    height: 100%;
    position: relative;
    text-align: center;
    vertical-align: middle;
`;

export const AwaitingDriverTitle = styled.label`
    font-weight: 300;
    font-size: 21px;
    position: fixed;
    top: 20%;
    left: 0;
    right: 0;
    color: #ffffff;
    line-height: 1.9;
    margin-left: 6px;
    margin-right: 6px;
`;

export const AwaitingDriverCancelContainer = styled.div`
    width: 100%;
    position: fixed;
    bottom: 20%;
`;

export const AwaitingDriverCancel = styled.div`
    width: 30%;
    display: table;
    margin-right: auto;
    margin-left: auto;
`;

export const AwaitingDriverCancelLabel = styled.label`
    font-weight: 100;
    font-size: 15px;
    color: #ffffff;
`;


// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/AwaitingDriver/AwaitingDriverStyle.js